<template>
    <el-col :lg="14" :sm="14" :xs="24">
        <h1 class="">Forget Password ?  reset HERE</h1>
        <el-card class="mb-20">
            <div class="text-center p-20 d-none">
                <img src="~@/assets/images/Logo.svg" alt="" class="k" width="200">
            </div>
            <el-form
                ref="ruleFormRef"
                :model="loginForm"
                status-icon
                label-width="120px"
                label-position="top"
                class="demo-ruleForm"
            >
                <el-form-item label="email" prop="email">
                    <el-input v-model="loginForm.email" type="email" autocomplete="off" />
                </el-form-item>
            
                <el-form-item>
                    <el-button type="primary" @click="submitForm('ruleFormRef')">Submit</el-button>
                    <!-- <el-button @click="resetForm('ruleFormRef')">Reset</el-button> -->
                </el-form-item>
            </el-form>
        </el-card>
        <router-link to="/admin/login"  class="no-decoration color-brown">
            Login
        </router-link>
    </el-col>
</template>
<script>
export default {
    data(){
        return {
            loginForm:{
                email: "admin@idealjeweler.com",
            }
        }
    },
    methods:{
        async submitForm(){
            const response = await this.$store.dispatch('adminResetPassword',this.loginForm);
            if (response.data.status == 1 ){
                this.$router.push({name:'login'})
            }
        },
    }
}
</script>